import { useEffect, useState } from 'react';

function parseAllowedIds(value) {
  if (!value) return [];
  try {
    const arr = JSON.parse(value);
    if (Array.isArray(arr)) {
      return arr.map(v => v.toString());
    }
  } catch {    
    if (typeof value === 'string') {
      return value.split(',').map(v => v.trim());
    }
  }
  return [];
}

const useFeatureFlag = (acontID) => {
  const flagName = process.env.REACT_APP_CHATBOT_ENABLE_CAMPAIGN;
  const environmentKey = process.env.REACT_APP_FLAGSMITH_ENV_KEY;
  const [hasPermission, setHasPermission] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!acontID || !flagName || !environmentKey) return;

    const fetchFlag = async () => {
      try {
        const res = await fetch(
          `https://api.flagsmith.com/api/v1/flags/?feature=${flagName}`,
          {
            headers: {
              'x-environment-key': environmentKey,
            },
          }
        );
        const flag = await res.json();

        if (!flag || !flag.hasOwnProperty('feature_state_value')) {
          setHasPermission(false);
          setIsReady(true);
          return;
        }

        if (flag.enabled === false) {
          setHasPermission(true);
          setIsReady(true);
          return;
        }

        const allowedIds = parseAllowedIds(flag.feature_state_value);
        const stringID = acontID.toString();
        const hasAccess = allowedIds.includes(stringID);

        setHasPermission(hasAccess);
        setIsReady(true);
      } catch (err) {
        setHasPermission(false);
        setIsReady(true);
      }
    };

    fetchFlag();
  }, [acontID, flagName, environmentKey]);

  return { hasPermission, isReady };
};

export default useFeatureFlag;